import React, {FC, useState} from "react";

import AnalyticsEtherBalance from "./analytics-ether-balance";
// import AnalyticsEtherTransfers from "./analytics-ether-transfers";
// import AnalyticsTokenTransfers from "./analytics-token-transfers";
// import AnalyticsTransaction from "./analytics-transaction";
// import AnalyticsTxnHeatmap from "./analytics-txn-heatmap";
// import AnalyticsTxnfees from "./analytics-txnfees";
import AnalyticsEtherReward from "./analytics-ether-reward";

const AnalyticsList: FC = () => {
    const [tab, setTab] = useState("etherbalance"); // Default tab is etherbalance

    return (
        <div className="bs-card">
            <div className="row py-3 px-4">
                <div className="col-lg-12">
                    <div className="bs-tab">
                        <button className={`bs-tab-item ${tab === "etherbalance" ? "active" : ""}`} onClick={() => setTab("etherbalance")}>
                            {process.env.REACT_APP_BASE_UNIT} Balance
                        </button>
                        {/* <button className={`bs-tab-item ${tab === "transaction" ? "active" : ""}`} onClick={() => setTab("transaction")}>
              Transactions
            </button>
            <button className={`bs-tab-item ${tab === "txnfees" ? "active" : ""}`} onClick={() => setTab("txnfees")}>
              TxnFees
            </button>
            <button className={`bs-tab-item ${tab === "ethertransfers" ? "active" : ""}`} onClick={() => setTab("ethertransfers")}>
              Ether Transfers
            </button>
            <button className={`bs-tab-item ${tab === "tokentransfers" ? "active" : ""}`} onClick={() => setTab("tokentransfers")}>
              Transfers
            </button>
            <button className={`bs-tab-item ${tab === "txnheatmap" ? "active" : ""}`} onClick={() => setTab("txnheatmap")}>
              Txn Heatmap
            </button> */}
                        <button className={`bs-tab-item ${tab === "ethersreward" ? "active" : ""}`} onClick={() => setTab("ethersreward")}>
                            Reward
                        </button>
                    </div>

                    <div className="bs-tab-content">
                        {tab === "etherbalance" && <AnalyticsEtherBalance/>}
                        {tab === "ethersreward" && <AnalyticsEtherReward/>}
                        {/* {tab === "transaction" && <AnalyticsTransaction />}
            {tab === "txnfees" && <AnalyticsTxnfees />}
            {tab === "ethertransfers" && <AnalyticsEtherTransfers />}
            {tab === "tokentransfers" && <AnalyticsTokenTransfers />}
            {tab === "txnheatmap" && <AnalyticsTxnHeatmap />} */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsList;
